import Link from "next/link";
import Popup from "../general/Popup";
import invoiceServices from "../../services/Invoice.services";
import { useRouter } from "next/router";


export default function SingleClient({
                                         i,
                                         id,
                                         uid,
                                         first_name,
                                         last_name,
                                         name,
                                         company_name,
                                         offerte,
                                         jwtToken,
                                         closeShowPopup
                                     }) {

    const router = useRouter();

    const attachClientToQuote = () => {
        invoiceServices.attachClient(offerte, id, jwtToken);
        closeShowPopup();
        router.reload();
    }

    return (
        <div>
            <div
                className="relative bg-white pr-4 py-2 flex items-center justify-between text-olaf-green-700 cursor-pointer singleClientItemGroup"
                onClick={attachClientToQuote}
            >
                <div
                    className="absolute top-0 -left-4 w-[calc(100%_+_2rem)] h-full bg-gray-100 hidden singleClientItem"></div>
                <div className={"relative flex flex-col truncate"}>
                                <span className=" font-bold truncate">
                                  {(company_name ? company_name + " - " : "") +
                                      first_name +
                                      " " +
                                      last_name}
                                </span>
                    <span className="text-xs italic truncate">
                                  Aangemaakt door: {first_name +
                        " " +
                        last_name}
                                </span>
                </div>

                <div
                    className="relative h-[40px] bg-olaf-green-100 rounded-tl-lg rounded-br-lg md:flex flex-row group items-center px-4 gap-4 actionsWrapper hidden">
                    <img
                        className={`opacity-100 actionsTransition hover:scale-125 h-[20px]`}
                        src="/assets/icon/invoice/check.svg"
                        alt={"action button"}
                    />
                </div>
            </div>
        </div>
    )
}